import { z } from 'zod'
import { citizenObject } from '~/packages/general/citizen/citizenObject'
import { dateOrIsoString } from '~/prix/types/date'
import sql from '~/prix/utils/sql'
import { equipmentObject } from '../equipment/equipmentObject'

export const equipmentLoanObject = z.object({
  id: z.string().uuid(),
  equipmentId: z.string().uuid(),
  loanDate: dateOrIsoString().nullish(),
  citizenId: z.string().uuid(),
  estimatedDevolutionDate: dateOrIsoString(),
  returned: z.boolean().nullish(),
  clientId: z.number().int().nullish(),
  sourceFilter: z.string().nullish(),
  insertUserId: z.string().nullish(),
  editUserId: z.string().nullish(),
  createdAt: dateOrIsoString().nullish(),
  updatedAt: dateOrIsoString().nullish(),
  citizen: citizenObject.nullish(),
  equipment: equipmentObject.nullish(),
})

export type EquipmentLoanType = z.infer<typeof equipmentLoanObject>

export const propertyMap = {
  id: sql`equipment_loan.id`,
  equipmentId: sql`equipment_loan.equipment_id`,
  loanDate: sql`equipment_loan.loan_date`,
  citizenId: sql`equipment_loan.citizen_id`,
  estimatedDevolutionDate: sql`equipment_loan.estimated_devolution_date`,
  returned: sql`equipment_loan.returned`,
  sourceFilter: sql`equipment_loan.source_filter`,
  clientId: sql`equipment_loan.client_id`,
  insertUserId: sql`equipment_loan.insert_user_id`,
  editUserId: sql`equipment_loan.edit_user_id`,
  createdAt: sql`equipment_loan.created_at`,
  updatedAt: sql`equipment_loan.updated_at`,
}

export default equipmentLoanObject
